import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
import useCustomer from '../hooks/useCustomer';

const AuthorizedRoute = ({ roles, targetCompany, bscAdmin, redirectPath, replace, children }) => {
	let location = useLocation();
	const { customer, hasRole, hasCompanyRole } = useCustomer();
	let authorized = bscAdmin ? customer.bscAdmin : true;
	if (authorized) {
		authorized = targetCompany ? hasCompanyRole(targetCompany, roles) : hasRole(roles);
	}

	if (!authorized) {
		// role not authorised so redirect to specified path
		return <Navigate to={redirectPath} state={{ from: location }} replace={replace} />;
	}

	return children;
};

AuthorizedRoute.defaultProps = {
	targetCompany: undefined,
	redirectPath: '/',
	bscAdmin: false,
	replace: true
};

AuthorizedRoute.propTypes = {
	/**
	 * component to render when route is valid
	 */
	children: PropTypes.any.isRequired,

	/**
	 * checks if customer is authorized for any of the affinity role(s) specified
	 */
	roles: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,

	/**
	 * Optional: company number to target for role check
	 */
	targetCompany: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

	/**
	 * Where to route the user to when un-authorized
	 */
	redirectPath: PropTypes.string,

	/**
	 * is route for bscAdmins only
	 */
	bscAdmin: PropTypes.bool,

	/**
	 * replaces the redirected route in the history stack for a better user experience
	 */
	replace: PropTypes.bool
};

export default AuthorizedRoute;
